// extracted by mini-css-extract-plugin
export default {"container":"table_container__uw6G5","truncate-table":"table_truncate-table__vjgEe","table-text-faded":"table_table-text-faded__FasRA","isLoading":"table_isLoading__71-+p","rows":"table_rows__l0G8q","table":"table_table__mVwKK","center":"table_center__5hIZB","right":"table_right__43+4c","noHover":"table_noHover__68nJy"};
    if(module.hot) {
      // 1792500639516
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  